import { createContext } from 'react';

const QueryParamsContext = createContext(null);

export default QueryParamsContext;
